import { Box, Typography } from '@mui/material';
import React, { memo } from 'react';

type Props = {
    title: string;
    hypothesisResumeContent: string | JSX.Element | JSX.Element[];
};

const GVTHypothesisResume = ({
    title,
    hypothesisResumeContent,
}: Props): React.ReactElement => (
    <Box>
        <Typography
            variant="body1Bold"
            sx={(theme) => ({
                color: theme.palette.darkGrey,
                mb: '0.2rem',
            })}
        >
            {title}
        </Typography>
        <Typography
            sx={(theme) => ({
                color: theme.palette.darkGrey,
            })}
        >
            {hypothesisResumeContent}
        </Typography>
    </Box>
);

export default memo(GVTHypothesisResume);
